import { HubConnectionState } from '@microsoft/signalr';
import { observer } from 'mobx-react';
import React from 'react';
import { dateFormat, ReactNodeGenerator, urlHelper } from '../../../lib/helpers';
import { ClassroomHubStore } from '../stores/ClassroomHubStore';
import { httpClient } from 'domain/utils/httpClient'
import { environment } from 'lib/environment';
import swal from 'sweetalert2';
import { Classroom } from '../models/classroom-models';
import { TeacherEditLessonModal, TeacherEditLessonModal_Data } from "lib/components/TeacherEditLessonModal";
import { TeacherCreateEssayModal, TeacherCreateEssayModal_Data } from "lib/components/TeacherCreateEssayModal";
import PubSub from 'pubsub-js';
import { routerStore } from 'lib/components';


function alertClassname(success: boolean): string {
  if (!success) {
    return 'alert alert-danger';
  }
  return 'alert alert-success';
}

function* renderer(store: ClassroomHubStore, classroom: Classroom): ReactNodeGenerator {
  const connectionClassName =
    alertClassname(store.connection.connectionState === HubConnectionState.Connected);

  async function CreateHomeworkClick() {
    if (store.keyValues.homeworkBlockIds.size == 0) {
      swal.fire({ icon: 'info', text: 'You need to add at least one block to homework' });
      return;
    }

    const url = `${environment.apiServer}/teacher/create-homework`;
    const data = { ClassroomId: store.classroomId };
    await httpClient.axios.postWithSweetAlert(url, data);
    swal.close();
    swal.fire({ icon: 'success', text: "Homework created OK" });
  }


  async function changeLessonClick() {
    const msgData: TeacherEditLessonModal_Data = {
      classroomId: classroom.Id,
      studentLevelId: classroom.Student!.Student!.LevelId!,
      unitId: classroom.Lesson!.UnitId,
      lessonId: classroom.LessonId
    };
    PubSub.publish("TeacherEditLessonModal_Open", msgData);
  }

  async function onCreateEssayClick() {
    const msgData: TeacherCreateEssayModal_Data = {
      classroomId: classroom.Id,
    };
    PubSub.publish("TeacherCreateEssayModal_Open", msgData);
  }

  yield (
    <TeacherEditLessonModal key="TeacherEditLessonModal-ClassroomHeader" onSaveSuccess={() => { }} />
  )
  yield (
    <TeacherCreateEssayModal key="TeacherCreateEssayModal-ClassroomHeader" onSaveSuccess={() => { }} />
  )

  const showTeacherButtons = store.role === 'Teacher'
    && store.join.joined
    && store.connection.connectionState == HubConnectionState.Connected
    && store.state.classroomState?.ClassroomStatus == 'InProgress';
  if (showTeacherButtons) {
    yield (
      <div className="col-auto" key="teacher-create-essay">
        <button className="btn btn-primary" style={{ padding: "0.75rem 1.25rem" }} onClick={onCreateEssayClick} >Create Essay</button>
      </div>
    );

    yield (
      <div className="col-auto" key="teacker-create-homework">
        <button className="btn btn-primary" style={{ padding: "0.75rem 1.25rem" }} onClick={CreateHomeworkClick} >Create Homework</button>
      </div>

    );

    yield (
      <div className="col-auto" key="teacker-change-lesson">
        <button className="btn btn-primary" style={{ padding: "0.75rem 1.25rem" }} onClick={changeLessonClick} >Change Lesson</button>
      </div>
    );
  }

  yield (
    <div className="col-auto" key="hub-connection-state">
      <div className={connectionClassName}>
        Connection: {store.connection.connectionState}
      </div>
    </div>);

  const classroomJoinedClassname = alertClassname(store.join.joined);
  yield (
    <div className="col-auto" key="classroom-joined-status">
      <div className={classroomJoinedClassname}>
        {store.join.joined
          ? 'You joined classroom'
          : 'Could not join classroom'
        }
      </div>
    </div>);

  if (!store.join.joined)
    return;

  const classroomState = store.state.classroomState!;
  if (classroomState === null)
    return;

  if (store.role === 'Student' && classroomState.TeacherFirstSeen === null)
    yield (
      <div className="col-auto" key="teacher-not-ready">
        <div className="alert alert-danger">
          Teacher is not ready
        </div>
      </div>
    );

  if (store.role === 'Student' && classroomState.TeacherLastSeen !== null)
    yield (
      <div className="col-auto" key="teacher-last-seen">
        <div className="alert alert-danger">
          Teacher last seen {dateFormat(classroomState.TeacherLastSeen, 'hms', true)}
        </div>
      </div>
    );

  if (store.role === 'Teacher' && !classroomState.StudentFirstSeen === null)
    yield (
      <div className="col-auto" key="student-not-ready">
        <div className="alert alert-danger">
          Student is not ready
        </div>
      </div>
    );

  if (store.role === 'Teacher' && classroomState.StudentLastSeen !== null)
    yield (
      <div className="col-auto" key="student-last-seen">
        <div className="alert alert-danger">
          Student last seen {dateFormat(classroomState.StudentLastSeen, 'hms', true)}
        </div>
      </div>
    );


}

@observer
export class ClassroomHeader extends React.Component<{
  store: ClassroomHubStore,
  classroom: Classroom,
  isPreview: boolean
}> {

  render() {
    if (this.props.isPreview) {
      return null;
    }
    const store = this.props.store;
    const classroom = this.props.classroom;

    return (
      <div className="row justify-content-end">
        {Array.from(renderer(store, classroom))}
      </div>);
  }
}
